/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  TreeSelect,
} from 'antd';
import { getTipoDeEmpleado } from 'api/catalogos';
import { getAreasExternas } from 'api/catalogos/AreaExterna';
import { getCategoriaDePuesto } from 'api/catalogos/categoriaDePuestos';
import { getEstadosPlazas } from 'api/catalogos/estadosPlazas';
import { getMotivosDeMovimientosDeEmpleados } from 'api/catalogos/motivoDeMovimientoDeEmpleados';
import { getNombramiento } from 'api/catalogos/Nombramientos';
import { getPlazavistaOptimized } from 'api/catalogos/plazas';
import { getPuesto, getPuestos } from 'api/catalogos/puestos';
import { getDatoOperacionalesDeHonorariosAsimilados } from 'api/estructuraOrganizacional/datosOperacionalesDeHonorarioAsimilado';
import CurrencyInput from 'components/CurrencyInput';
import Select from 'components/Select';
import moment from 'moment/moment';
import React, {
  useEffect, useMemo, useState,
} from 'react';
import { ESTADO_PLAZA_ASIGNADA, ESTATUS_AUTORIZADO } from 'utils/constants';

// El endpoint de áreas regresa un listado plano (id, clave, nombre, directorio_area_padre);
// TreeSelect necesita nodos {title, value, key, children} para poder mostrar las etiquetas.
const buildAreasTreeData = (areasData = []) => {
  const nodeById = new Map(areasData.map((item) => [item.id, {
    title: `${item.clave} - ${(item.nombre || '').trim()}`,
    value: item.id,
    key: item.id,
    children: [],
  }]));

  const tree = [];
  areasData.forEach((item) => {
    const node = nodeById.get(item.id);
    const parentNode = nodeById.get(item.directorio_area_padre);
    if (parentNode) {
      parentNode.children.push(node);
    } else {
      tree.push(node);
    }
  });

  return tree;
};
// eslint-disable-next-line react/prop-types
const HonorarioAsimiladoAdscripcion = ({
  form,
  rules,
  puestos,
  formPlazas,
  areas,
  categoriaDePuestos,
  tiposHonorariosAsimilados,
  tiposDeFunciones,
  tabuladoresGenerales,
  calcularAntiguedad,
  setFechaDeAlta,
  setFechaDeBaja,
  setFechaDeReingreso,
  isBlocked,
  honorarioAsimilado,
  nombramientosSinPaginar,
  plazaHonorarioAsimilado,
}) => {
  const [tabuladorGeneral, setTabuladorGeneral] = useState();
  const [tipoHonorarioAsimilado, setTipoHonorarioAsimilado] = useState();
  const [categoria, setCategoria] = useState();
  const [motivoAltaRequerido, setMotivoAltaRequerido] = useState(false);
  const [motivoBajaRequerido, setMotivoBajaRequerido] = useState(false);
  const [motivosMovimientos, setMotivosMovimientos] = useState([]);
  const [motivosMovimiento, setMotivosMovimiento] = useState([]);
  const [, setTipoFuncionId] = useState(null);
  const [cuipHabilitadoLocal, setCuipHabilitadoLocal] = useState(false);
  const [tiposDeFuncionesLocal] = useState([]);
  const [estadosPlaza, setEstadosPlaza] = useState([]);
  const [areasExternas, setAreasExternas] = useState([]);
  const [isComisionadoExterno, setIsComisionadoExterno] = useState(false);

  const areasTreeData = useMemo(() => buildAreasTreeData(areas), [areas]);

  const evaluarFuncion = (valor) => {
    const funcionSeleccionada = tiposDeFunciones.find((f) => f.id === valor);
    const esSeguridadPublica = funcionSeleccionada?.descripcion === 'Seguridad Pública';
    setCuipHabilitadoLocal(esSeguridadPublica);
    if (!esSeguridadPublica) {
      form.setFieldsValue({ cuip: null });
    }
  };
  const changeFechaAlta = async (value) => {
    const _motivosMovimientosHonorariosAsimilados = await getMotivosDeMovimientosDeEmpleados();
    setMotivosMovimientos(_motivosMovimientosHonorariosAsimilados);
    setFechaDeAlta(value);
    if (value) {
      setMotivoAltaRequerido(true);
      form.setFieldsValue({
        antiguedad: calcularAntiguedad(value),
      });
    } else {
      setMotivoAltaRequerido(false);
      form.setFieldsValue({
        antiguedad: null,
        motivo_alta: null,
      });
    }
  };

  const changeFechaBaja = async (value) => {
    const _motivosMovimientosHonorariosAsimilados = await getMotivosDeMovimientosDeEmpleados();
    setMotivosMovimientos(_motivosMovimientosHonorariosAsimilados);
    setFechaDeBaja(value);
    if (value) {
      setMotivoBajaRequerido(true);
    } else {
      setMotivoBajaRequerido(false);
      form.setFieldsValue({ motivo_baja: null });
    }
  };
  useEffect(() => {
    const toMoment = (val) => (val ? moment(val) : null);

    const fetch = async () => {
      try {
        if (!form || !formPlazas || !honorarioAsimilado) return;

        const [
          _estadosPlaza,
          motivos,
          _areasExternas,
        ] = await Promise.all([
          getEstadosPlazas(),
          getMotivosDeMovimientosDeEmpleados(),
          getAreasExternas(),
        ]);

        setMotivosMovimiento(motivos);
        setEstadosPlaza(_estadosPlaza);
        setAreasExternas(_areasExternas);

        const datosOp = await getDatoOperacionalesDeHonorariosAsimilados({ honorario_asimilado: honorarioAsimilado });
        if (!datosOp?.length) return;

        const dato = datosOp[0];

        // === 1. Sueldo desde datos operacionales solamente ===
        const sueldoMensual = parseFloat(dato.sueldo_mensual) || null;
        const sueldoDiario = sueldoMensual ? (sueldoMensual / 30).toFixed(2) : null;

        formPlazas.setFieldsValue({
          sueldo_mensual: sueldoMensual,
          sueldo_diario: sueldoDiario,
        });

        let nombramiento = null;

        // === 2. Cargar nombramiento si existe ===
        if (dato.nombramiento) {
          nombramiento = await getNombramiento(dato.nombramiento);
        }

        // === 3. Fechas y motivos ===
        const fechaAltaGob = dato.fecha_de_alta_en_gobierno || nombramiento?.fecha_de_alta_en_gobierno;
        const fechaAlta = dato.fecha_de_alta || nombramiento?.fecha_de_alta;
        const fechaBaja = dato.fecha_de_baja || nombramiento?.fecha_de_baja;
        const fechaReingreso = dato.fecha_de_reingreso || nombramiento?.fecha_de_reingreso;

        const motivoAltaId = dato.motivo_alta ?? nombramiento?.motivo_alta ?? null;
        const motivoBajaId = dato.motivo_baja ?? nombramiento?.motivo_baja ?? null;

        form.setFieldsValue({
          fecha_de_alta_en_gobierno: toMoment(fechaAltaGob),
          fecha_de_alta: toMoment(fechaAlta),
          fecha_de_baja: toMoment(fechaBaja),
          fecha_de_reingreso: toMoment(fechaReingreso),
          motivo_alta: motivoAltaId,
          motivo_baja: motivoBajaId,
          antiguedad: fechaAlta ? calcularAntiguedad(toMoment(fechaAlta)) : null,
        });

        if (fechaAlta) setMotivoAltaRequerido(true);
        if (fechaBaja) setMotivoBajaRequerido(true);

        // === 4. Cargar plaza desde ID ===
        if (dato.plaza) {
          const plaza = await getPlazavistaOptimized(dato.plaza);

          if (plaza) {
            setIsComisionadoExterno(dato.comisionado_en_area_externa || false);

            formPlazas.setFieldsValue({
              // No. de plaza
              clave: plaza.clave || plaza.clave_y_descripcion?.split(' - ')[0] || dato.plaza_no || null,

              // Área
              directorio_area:
              plaza.directorio_area?.trim()
              || plaza.directorio_area_clave_y_nombre?.split(' - ')[1]?.trim()
              || dato.directorio_de_area_nombre?.trim()
              || dato.directorio_de_area_clave_y_nombre?.trim()
              || null,

              // Puesto
              puesto:
              plaza.puesto?.trim()
              || plaza.descripcion?.trim()
              || dato.puesto_descripcion?.trim()
              || dato.puesto_clave_y_descripcion?.split(' - ')[1]
              || null,

              // Categoría de honorario asimilado
              categoria_de_honorario_asimilado:
              plaza.categoria_de_empleado?.trim()
              || dato.categoria_nombre?.trim()
              || null,

              // Tipo de honorario asimilado
              tipo_de_honorario_asimilado:
              plaza.tipo_de_empleado?.trim()
              || plaza.tipo_nomina_empleado?.trim()
              || dato.tipo_empleado_descripcion?.trim()
              || null,

              // Coordinación
              coordinacion: plaza.coordinacion?.trim() || plaza.coordinacion_nombre?.trim() || null,

              // Comisión externa
              comisionado_en_area_externa: dato.comisionado_en_area_externa || false,
              area_externa_de_comision: dato.area_externa_de_comision || null,
              directorio_de_area_comision: dato.directorio_de_area_comision || null,

              // Sueldos desde plaza (si aplica)
              sueldo_diario: parseFloat(plaza.sueldo_diario_nominal_asignado) || sueldoDiario,
              sueldo_mensual: parseFloat(plaza.sueldo_mensual_nominal_asignado) || sueldoMensual,
            });
          } else { /* ignore */ }
        }

        // === 5. Tipo de función ===
        if (dato.tipo_de_funcion) {
          form.setFieldsValue({ tipo_de_funcion: dato.tipo_de_funcion });
          evaluarFuncion(dato.tipo_de_funcion);
        }

        // === 6. Cargar motivos de movimientos autorizados (altas/bajas) ===
        const _motivosMovimientosHonorariosAsimilados = await getMotivosDeMovimientosDeEmpleados();
        setMotivosMovimientos(_motivosMovimientosHonorariosAsimilados);

        // === 7. Validar motivos existentes ===
        if (
          motivoAltaId
        && !_motivosMovimientosHonorariosAsimilados.some((m) => m.id === motivoAltaId)
        ) {
          form.setFieldsValue({ motivo_alta: 'N/A' });
        }

        if (
          motivoBajaId
        && !_motivosMovimientosHonorariosAsimilados.some((m) => m.id === motivoBajaId)
        ) {
          form.setFieldsValue({ motivo_baja: 'N/A' });
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('[Adscripción del Honorario Asimilado] error al cargar datos operacionales/plaza', err);
      }
    };

    fetch();
  }, [honorarioAsimilado, form, formPlazas, puestos, areas, tiposHonorariosAsimilados, categoriaDePuestos]);

  useEffect(() => {
    const tipoFuncion = form.getFieldValue('tipo_de_funcion');

    if (
      tipoFuncion !== undefined
      && tipoFuncion !== null
      && tiposDeFunciones.length > 0
    ) {
      evaluarFuncion(tipoFuncion);
    }
  }, [tiposDeFunciones, form]);

  return (
    <>
      <Form
        layout="vertical"
        form={form}
        scrollToFirstError
        name="general"
      >
        <Card
          type="inner"
          size="small"
          className="inner-block-card"
          title="1. Movimientos De Alta, Baja Y Reingreso"
          extra="Historial De Ingreso Y Salida"
        >
          <Row gutter={10}>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="fecha_de_alta_en_gobierno"
                label="Fecha de Alta en Gobierno"
                hasFeedback
              >
                <DatePicker
                  placeholder=""
                  format="DD/MM/YYYY"
                  disabled={isBlocked}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="fecha_de_alta"
                label="Fecha de Alta"
                // rules={rules.fecha_de_alta}
                hasFeedback
              >
                <DatePicker
                  placeholder=""
                  format="DD/MM/YYYY"
                  onChange={(value) => changeFechaAlta(value)}
                  disabled={isBlocked}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="motivo_alta"
                label="Motivo de Alta"
                 // rules={rules.required}
                hasFeedback
              >
                <Select
                  disabled={!motivoAltaRequerido || isBlocked}
                  dataSource={
                    motivosMovimientos.filter((e) => e.tipos_de_movimientos_de_empleados === 1)
                  }
                  render={(value) => `${value?.concepto}`}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="fecha_de_baja"
                label="Fecha de Baja"
                // rules={rules.fecha_de_baja}
                hasFeedback
              >
                <DatePicker
                  placeholder=""
                  format="DD/MM/YYYY"
                  onChange={(value) => changeFechaBaja(value)}
                  disabled={isBlocked}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="motivo_baja"
                label="Motivo de Baja"
                rules={motivoBajaRequerido ? rules.required : null}
                hasFeedback
              >
                <Select
                  disabled={!motivoBajaRequerido || isBlocked}
                  dataSource={
                    motivosMovimientos
                  }
                  render={(value) => `${value?.concepto}`}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="fecha_de_reingreso"
                label="Fecha de Reingreso"
                // rules={rules.fecha_de_reingreso}
                hasFeedback
              >
                <DatePicker
                  placeholder=""
                  format="DD/MM/YYYY"
                  onChange={(value) => {
                    setFechaDeBaja();
                    setFechaDeReingreso(value);
                    setMotivoBajaRequerido(false);
                    form.resetFields([
                      'fecha_de_baja',
                      'motivo_baja',
                    ]);
                  }}
                  disabled={isBlocked}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="antiguedad"
                label="Antigüedad"
              >
                <Input disabled />
              </Form.Item>
            </Col>
            {/*
            <Col xs={24} sm={24} md={16}>
              <Form.Item
                name="obligado_a_presentar_declaracion_patrimonial"
                label="¿Está Obligado a Presentar Declaración Patrimonial?"
                rules={rules.required}
                hasFeedback
              >
                <Select
                  trueFalse
                  disabled={isBlocked}
                />
              </Form.Item>
            </Col>
            */}
          </Row>
          <Row gutter={10}>
            {/* }
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="solicita_no_presentar_calculo_anual_isr"
                label="Presenta Constancia para no Cálculo Anual"
                rules={rules.required}
                hasFeedback
              >
                <Select
                  trueFalse
                  disabled={isBlocked}
                />
              </Form.Item>
            </Col>
            */}
            {/*
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="fecha_de_aviso_no_calculo_anual_isr"
                label="Fecha de Aviso para Cálculo Anual de ISR"
                hasFeedback
              >
                <DatePicker
                  placeholder=""
                  format="DD/MM/YYYY"
                  disabled={isBlocked}
                />
              </Form.Item>
            </Col>
            */}
          </Row>
        </Card>
      </Form>

      <Card
        type="inner"
        size="small"
        className="inner-block-card"
        title="2. Plaza, Puesto Y Área"
        extra="Adscripción Organizacional Actual"
      >
        <Form
          layout="vertical"
          form={formPlazas}
          scrollToFirstError
          name="plazas"
        >
          <Row gutter={10}>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="clave"
                label="No. de Plaza"
                hasFeedback
              >
                <Input allowClear disabled />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="directorio_area"
                label="Área"
                hasFeedback
              >
                <Input allowClear disabled />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="puesto"
                label="Puesto"
                hasFeedback
              >
                <Input allowClear disabled />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="categoria_de_honorario_asimilado"
                label="Categoría de Honorario Asimilado"
                hasFeedback
              >
                <Input allowClear disabled />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="tipo_de_honorario_asimilado"
                label="Tipo de Honorario Asimilado"
                hasFeedback
              >
                <Input allowClear disabled />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={8}>
              <CurrencyInput
                name="sueldo_diario"
                label="Sueldo Diario"
                disabled
              />
            </Col>

            <Col xs={24} sm={24} md={8}>
              <CurrencyInput
                name="sueldo_mensual"
                label="Sueldo Mensual"
                onChange={(val) => form.setFieldValue('sueldo_diario', (val / 30).toFixed(2))}
                disabled
              />
            </Col>
          </Row>
        </Form>
        <Form
          layout="vertical"
          form={form}
          scrollToFirstError
          name="general-funcion"
        >
          <Row gutter={10}>
            {/* Obtener de la plaza del honorario asimilado */}
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="tipo_de_funcion"
                label="Tipo de Función"
                // rules={rules.required}
                hasFeedback
              >
                <Select
                  keyProp="id"
                  labelProp="descripcion"
                  dataSource={tiposDeFunciones}
                  disabled
                  onChange={(value) => {
                    setTipoFuncionId(value);
                    evaluarFuncion(value);
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="coordinacion"
                label="Coordinación"
                hasFeedback
              >
                <Input allowClear disabled />
              </Form.Item>
            </Col>
            {cuipHabilitadoLocal && (
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="cuip"
                  label="CUIP Clave Única de Identificación Permanente"
                  rules={[{ required: true, message: 'CUIP es requerido cuando la función es Seguridad Pública' }]}
                  hasFeedback
                >
                  <Input disabled={isBlocked} />
                </Form.Item>
              </Col>
            )}
          </Row>
        </Form>
      </Card>

      <Card
        type="inner"
        size="small"
        className="inner-block-card"
        title="3. Comisión En Área Externa"
        extra="Aplica Solo Si El Honorario Asimilado Está Comisionado"
      >
        <Form
          layout="vertical"
          form={formPlazas}
          scrollToFirstError
          name="plazas-comision"
        >
          <Row gutter={10}>
            <Col xs={24} sm={24} md={12}>
              <Form.Item
                name="comisionado_en_area_externa"
                label="Comisionado en Área Externa"
                hasFeedback
              >
                <Select
                  trueFalse
                  disabled={isBlocked}
                  onChange={(value) => {
                    setIsComisionadoExterno(value);
                    if (value) {
                      formPlazas.setFieldsValue({ directorio_de_area_comision: null });
                    } else {
                      formPlazas.setFieldsValue({ area_externa_de_comision: null });
                    }
                  }}
                />
              </Form.Item>
            </Col>

            {isComisionadoExterno ? (
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="area_externa_de_comision"
                  label="Área Externa de Comisión"
                  hasFeedback
                >
                  <Select
                    dataSource={areasExternas}
                    keyProp="id"
                    labelProp="nombre_del_area"
                    disabled={isBlocked}
                    allowClear
                  />
                </Form.Item>
              </Col>
            ) : (
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="directorio_de_area_comision"
                  label="Área de Comisión"
                  hasFeedback
                >
                  <TreeSelect
                    showSearch
                    treeData={areasTreeData}
                    treeNodeFilterProp="title"
                    disabled={isBlocked}
                    allowClear
                  />
                </Form.Item>
              </Col>
            )}
          </Row>
        </Form>
      </Card>

      <Card
        type="inner"
        size="small"
        className="inner-block-card"
        title="4. Estatus De Asignación De Plaza"
        extra="Movimiento Más Reciente"
      >
        <Form
          layout="vertical"
          form={form}
          scrollToFirstError
          name="datos nuevos datoOp"
        >
          <Row gutter={10}>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="estado_plaza"
                label="Estatus de la Plaza"
                hasFeedback
                initialValue={ESTADO_PLAZA_ASIGNADA}
              >
                <Select dataSource={estadosPlaza} disabled />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="fecha_asignacion_desasignacion"
                label="Fecha de Asignación o Desasignación"
                hasFeedback
              >
                <DatePicker
                  allowClear
                  format="DD/MM/YYYY"
                  placeholder=""
                  disabled
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="motivo_asignacion_desasignacion"
                label="Motivo de Asignación o Desasignación"
                hasFeedback
              >
                <Select
                  dataSource={motivosMovimiento}
                  render={(value) => `${value?.concepto}`}
                  disabled
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
    </>
  );
};

export default HonorarioAsimiladoAdscripcion;
